import API from '../api';

export const tradingHistoryList = (params) => API.get(`/api/v1/trading-history?${params}`);
